export default function initDrawers() {
	const $html = document.getElementsByTagName("html")[0];
	const $drawers = document.querySelector(".drawer");
	const $drawerButtons = getAll(".js-drawer");
	const $drawerCloses = getAll(".drawer__bg, .drawer__close");

	if ($drawerButtons.length > 0) {
		$drawerButtons.forEach(($el) => {
			$el.addEventListener("click", () => {
				$drawers.classList.add("drawer--active");
				$html.classList.add("no-body-scroll");
			});
		});
	}


	if ($drawerCloses.length > 0) {
		$drawerCloses.forEach(($el) => {
			$el.addEventListener("click", () => {
				closeDrawers();
			});
		});
	}

	document.addEventListener("keydown", (event) => {
		const e = event || window.event;
		if (e.keyCode === 27) {
			closeDrawers();
		}
	});

	function closeDrawers() {
			$drawers.classList.add("drawer--closing");
			$html.classList.remove("no-body-scroll");
			setTimeout(function () {
				$drawers.classList.remove("drawer--active");
				$drawers.classList.remove("drawer--closing");
  		}, 300);

	}

	function getAll(selector) {
		return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
	}
}
